import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { getJson } from '../../helpers/RequestsHelper'

import FilterSelector from '../../components/FilterSelector';
import SelectObject from './Inputs/SelectObject'

import BlockSetupInput from './Inputs/BlockSetupInput'
import AccountSelect from '../../components/AccountSelect'
import AvailableFields from './Inputs/AvailableFields'
import ConfirmationPopup from '../../components/ConfirmationPopup'

import { HEADER } from '../../components/react-cron-generator';
import Cron from '../../components/react-cron-generator'
import '../../components/react-cron-generator/cron-builder.css'

import Modal from 'react-bootstrap/Modal';

import { supportedApps, appsWithTriggers, appsWithActions, getActions, allActions } from '../../helpers/applications'
import { globalState } from '../../helpers/constants';

class BlockSetup extends Component {

  state = {
    loading: true
  }

  static getDerivedStateFromProps(props, state) {
    if (props.block.params && props.block.params.login) {
      state.accountId = props.block.params.login.accountId
    } else {
      state.accountId = undefined
    }
    if (state.show !== false) {
      state.show = props.show
      if (props.show) {
        sessionStorage.setItem("PopupVisible", props.popupId)
      }
    }

    state.workflow = props.workflow
    return state
  }

  constructor() {
    super()
    this.onInputValueChange = this.onInputValueChange.bind(this)
    this.onApplicationTypeSelect = this.onApplicationTypeSelect.bind(this)
    this.onActionSelect = this.onActionSelect.bind(this)
    this.onAccountSelect = this.onAccountSelect.bind(this)
    this.onTested = this.onTested.bind(this)
    this.onDelete = this.onDelete.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.onUpdate = this.onUpdate.bind(this)
    this.onHide = this.onHide.bind(this)
    this.onChangeAction = this.onChangeAction.bind(this)
    this.loadApplications = this.loadApplications.bind(this)

    this.modalRef = React.createRef();
  }

  componentDidMount() {
    this.loadApplications()
  }

  async loadApplications() {
    if (this.props.block.application) {
      await this.onApplicationTypeSelect({ id: this.props.block.application })
    } else {
      this.props.loadBlockTypes(this.props.block)
      this.setState({ loading: false })
    }
  }

  onHide() {
    sessionStorage.removeItem("PopupVisible")
    this.setState({ show: false }, () => this.onUpdate())
  }

  onRefresh() {
    //This didn't work this.forceUpdate();
    //TODO: Find how to refresh only the current component
    window.location = window.location
  }

  async onChangeAction(changeBlock) {
    if (changeBlock) {
      const newBlock = this.state.confirmBlock
      this.setState({ newBlock, changeActionConfirmation: false }, () => this.onUpdate(newBlock))
    } else {
      const newBlock = this.props.block
      this.setState({ newBlock, changeActionConfirmation: false }, () => this.onUpdate(newBlock))
    }
  }

  async onApplicationTypeSelect(applicationObj) {
    const application = applicationObj.id

    let newBlock = { ...this.props.block }
    if (newBlock.application != application) {
      const oldApplication = newBlock.application
      await getActions(application)
      newBlock.application = application
      delete newBlock.action
      delete newBlock.params
      newBlock.needChildrenReset = true
      if (oldApplication) {
        this.setState({ confirmBlock: newBlock, changeActionConfirmation: true, loading: false })
      } else {
        this.onUpdate(newBlock)
      }
    } else {
      this.setState({ loading: false })
    }
  }

  onActionSelect(action) {
    let newBlock = { ...this.props.block }
    if (newBlock.action != action) {
      delete newBlock.label
      const oldAction = newBlock.action
      newBlock.action = action
      if (action.converters) {
        newBlock.converters = action.converters
      }
      newBlock.tested = false

      newBlock.needChildrenReset = true

      if (oldAction) {
        this.setState({ confirmBlock: newBlock, changeActionConfirmation: true, loading: false })
      } else {
        this.onUpdate(newBlock)
      }
    }
  }

  onInputValueChange(stepId, property) {
    let params = this.props.block.params
    if (!params) {
      params = {}
    }
    params[stepId] = property

    let block = this.props.block
    block.params = params

    this.onUpdate(block)
  }

  onDelete() {
    this.props.onDelete(this.props.block)
  }

  //   updateWorklowForSaving(workflow) {
  //     flow.flowId = this.state.flow._id
  //     flow.title = this.state.flow.title
  //     flow.blocks = []
  //     for (let index = 0; index < this.state.flow.blocks.length; index++) {
  //         const block = this.state.flow.blocks[index]
  //         const fullBlock = this.state[block.id]
  //         block.params = {}
  //         for (let i = 0; i < fullBlock.steps.length; i++) {
  //             const stepId = fullBlock.steps[i].id
  //             const stepValues = JSON.parse(sessionStorage.getItem(BlockSetup.getKey(block.id,stepId)))
  //             block.params[stepId] = stepValues;
  //         }
  //         flow.blocks.push(block)
  //     }
  //     return flow
  // }
  onUpdate(block) {
    if (block) {
      this.props.onUpdate(block, this.state.show)
    } else {
      if (this.props.block.action && this.props.block.type !== "start" && this.props.block.type != "application") {
        //let newBlock = { ...this.props.block }
        //newBlock.type = "application"
        this.props.block.type = "application"
        this.props.onUpdate(this.props.block, this.state.show)
      } else {
        this.props.onUpdate(this.props.block, this.state.show)
      }
    }
  }

  onAccountSelect(selectedApp) {
    if (selectedApp) {
      if (this.state.accountId !== selectedApp.accountId) {
        let newState = { accountId: selectedApp.accountId }

        this.setState(newState)
        this.onInputValueChange("login", { accountId: selectedApp.accountId })
      }
    } else {
      if (this.state.accountId !== undefined) {
        this.setState({ accountId: undefined, tested: false })
        this.onInputValueChange("login", undefined)
      }
    }
  }

  onTested(tested) {
    let block = this.props.block
    block.tested = tested

    this.onUpdate(block)
  }

  static getKey = (blockId, stepId) => {
    return "BlockSetup_" + blockId + "_" + stepId
  }

  render() {
    const t = this.props.t
    if (this.state.loading) {
      return <div className="spinner-border" role="status">
        <span className="sr-only">{t("loading")}</span>
      </div>
    }

    const action = this.props.block.action

    let inputs = []


    inputs.push(
      <SelectObject key="app_selector"
        id="application"
        // groups={[
        //   { name: "Applications", items: publicApps },
        //   { name: "Awaiting Certification", items: underCertificationApps }
        // ]}
        items={this.props.block.type === "start" ? appsWithTriggers : appsWithActions}
        fieldName="name"
        title={t("lbl_select_application")}
        placeholder={t("lbl_placeholder_application")}
        onSelect={this.onApplicationTypeSelect}
        autoFocus={this.props.block.application ? false : true}
        selected={supportedApps.find(a => a.id === this.props.block.application)} />)

    inputs.push(<br key="br1" />)
    const actions = allActions[this.props.block.application]
    if (actions) {
      var possibleBlocks = actions.blocks.filter(item => !item.hidden && (this.props.block.type === "start" ? item.trigger : !item.trigger)).sort((a, b) => (a.name > b.name) ? 1 : -1)
      var popularBlocks = possibleBlocks.filter(item => actions.popularActions && actions.popularActions.includes(item.id))
      if (popularBlocks && popularBlocks.length > 0) {
        inputs.push(<SelectObject
          id="action"
          key={this.props.block.application + (action ? action.id : "action")}
          groups={[
            { name: "Popular", items: popularBlocks },
            { name: "All", items: possibleBlocks }
          ]}
          fieldName="name"
          fieldDescription="description"
          title={t("lbl_select_block")}
          onSelect={this.onActionSelect}
          selected={action} />)
      } else {
        inputs.push(<SelectObject
          id="action"
          key={this.props.block.application + (action ? action.id : "action")}
          items={possibleBlocks}
          fieldName="name"
          fieldDescription="description"
          title={t("lbl_select_block")}
          onSelect={this.onActionSelect}
          selected={action} />)
      }

      inputs.push(<br key="br2" />)
      //if (this.props.block.type === "start") {
      if (this.props.block.application === "simplyflows_schedule") {
        //reseting to the dafult order, as the build was not working
        //const cronOptions = { headers: [HEADER.MONTHLY, HEADER.WEEKLY, HEADER.DAILY, HEADER.HOURLY, HEADER.MINUTES] }
        inputs.push(<><Cron
          key="cron"
          onChange={(e) => { this.onInputValueChange("cron", e) }}
          value={this.props.block.params ? this.props.block.params["cron"] : ""}
          showResultText={true}
          showResultCron={false}
          //options={cronOptions}
        />
        <span className="small">Dates and times are in the [{globalState.user.zoneinfo ? globalState.user.zoneinfo.name : "America/New York"}] timezone. If you'd like to change that, choose a different timezone on your <a href="/user/profile">profile</a>.</span>
        </>)
      }
    }

    if (action && action != "" && action.steps) {
      //TODO: Move the scheduler as a separate step when we support multiple
      //let hasSchedulerStep = false
      for (let i = 0; i < action.steps.length; i++) {
        const step = action.steps[i];
        const key = action.id + step.id
        const value = this.props.block.params ? this.props.block.params[step.id] : undefined
        if (step.type === "login") {
          var accountType = step.accountType;
          inputs.push(t("lbl_select_account"))
          inputs.push(<AccountSelect accountType={accountType} requiredScope={step.requiredScope} onChange={this.onAccountSelect} key={key} selectedAccountId={this.state.accountId} />)

          if (!this.state.accountId) {
            break
          }
        } else if (step.type === "test") {
          if (this.props.inputTypes && this.props.inputTypes.length > 0) {
            inputs.push(<br key={key + "br0"} />)
            if (this.state.stashVisible) {
              const stashValue = this.props.block.params ? this.props.block.params["stash"] : undefined
              const stashStep =
              {
                "id": "stash",
                "type": "fields",
                "label": "Stash (fields to keep till the end of the workflow)"
              }
              inputs.push(<BlockSetupInput step={stashStep} block={this.props.block} inputTypes={this.props.inputTypes} accountId={this.state.accountId} onChange={this.onInputValueChange} key="stash" value={stashValue} workflow={this.props.workflow} />)
            } else {
              inputs.push(<>Advanced settings <button onClick={() => this.setState({ stashVisible: !this.state.stashVisible })} className="icon-button" title="Show advanced settings"><i className="fas fa-caret-down"></i></button></>)
              inputs.push(<br key={key + "br01"} />)
            }
          }
          step.label = t("lbl_test")
          inputs.push(<br key={key + "br1"} />)
          inputs.push(<BlockSetupInput step={step} block={this.props.block} accountId={this.state.accountId} onChange={this.onTested} key={key} />)
        } else if (action.steps[i].type !== "login" || this.state.accountId) {
          inputs.push(<br key={key + "br2"} />)
          inputs.push(<BlockSetupInput step={step} block={this.props.block} inputTypes={this.props.inputTypes} accountId={this.state.accountId} onChange={this.onInputValueChange} key={key} value={value} workflow={this.props.workflow} />)
        }
      }
    }
    //TODO: Localize
    return <Modal id={this.props.popupId} ref={this.modalRef} show={this.state.show} onHide={this.onHide} className={"workflow-block-setup"} style={{paddingLeft: '32px'}}>
      <Modal.Body>
        {this.props.isLegacy?
          <div className="row">
            <div className="col-10 flowpage" id="block">
              {inputs}
            </div>
            <div className="col-2 available-fields">
              {this.props.inputTypes && this.props.inputTypes.length > 0 ? <AvailableFields types={this.props.inputTypes} application={this.props.block.application} isLegacy={this.props.isLegacy}/> : ""}
            </div>
          </div>
        :
          <div className="row">
            <div className="col-6 flowpage" id="block" style={{flexGrow: 10}}>
              {inputs}
            </div>
            <div className="col-6 available-fields" style={{flexShrink: 2}}>
              {this.props.inputTypes && this.props.inputTypes.length > 0 ? <AvailableFields types={this.props.inputTypes} application={this.props.block.application} isLegacy={this.props.isLegacy}/> : ""}
            </div>
          </div>
        }
        <ConfirmationPopup
          show={this.state.changeActionConfirmation}
          title={t("title_change_action_confirm")}
          onConfirm={() => this.onChangeAction(true)}
          confirmId={this.props.block.id}
          onHide={() => this.setState({ changeActionConfirmation: false }, () => this.onChangeAction(false))}
          text={t("text_change_action_confirm")}
          buttonText={t("btn_change_action_confirm")} />
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className={this.props.block.tested ? "submit-btn mr-auto" : "submit-btn-2 mr-auto"} data-dismiss="modal" onClick={this.onHide} data-flowid={this.props.block.id} id="done">{t("btn_done")}</button>

        {this.props.block.type !== "start" ? <button type="button" className="submit-btn-2" onClick={() => this.setState({ showDeleteConfirmation: true })} >{t("btndeleteconfirm")}</button> : ""}
        <ConfirmationPopup show={this.state.showDeleteConfirmation}
          title={t("lbldeleteconfirm")}
          onConfirm={this.onDelete}
          confirmId={this.props.block.id}
          onHide={() => this.setState({ showDeleteConfirmation: false })}
          text={t("lblblockdeleteconfirm")}
          buttonText={t("btndeleteconfirm")} />
        <ConfirmationPopup popupId="deleteBlock" title={t("lblblockdeleteconfirm")} onConfirm={this.onDelete} text={t("btndeleteconfirm")} />
        {this.props.block.type !== "start" ? <button type="button" className="submit-btn-2" data-dismiss="modal" onClick={this.onRefresh} >{t("btnrefresh")}</button> : ""}
        &nbsp;&nbsp;&nbsp;

      </Modal.Footer>
    </Modal>
  }
}

export default withTranslation()(BlockSetup)
